import {toINR} from "../../../service/numberFormat";
import * as React from "react";
import IPlan from "../IPTypes";

export default function PlanOverviewMob(plan: IPlan, showPlanModalFunc?: (val: boolean) => any) {
    return (
        <>
            <div className={"benefits clr_card row " + plan.color}>
                <div>
                    <p className="pName ib">{plan.name}</p>
                    {plan.type && (
                        <p className="pType ib">
                            <span className="hypen">-</span>
                            {plan.type}
                        </p>
                    )}

                    <p className="pValue">
						<span className="ib ">
							<b>₹</b>
                            {toINR(plan.value.split("/yr")[0], 0)}
						</span>
                    </p>
                    {showPlanModalFunc && (
                        <button className="close_link" onClick={() => showPlanModalFunc(false)}>
                            <i className="edel-icon-close"></i>
                        </button>
                    )}
                </div>
            </div>
            <div className="row2 row">
                <div>
                    <label className="row_lbl">Validity</label>

                    <label className="row_val">{plan.validity}</label>
                </div>
                <div>
                    <label className="row_lbl">Brokerage</label>
                    <label className="row_val">{plan.brokerage}</label>
                </div>
                <div>
                    <label className="row_lbl">DPC Charges</label>
                    <label className="row_val">{plan.DPC_charges}</label>
                </div>
            </div>
            <div className="row3 row">
                <div>
                    <label className="row_lbl">FNO DPC</label>
                    <label className="row_val">{plan.FNO_DPC}</label>
                </div>
                <div>
                    <label className="row_lbl">Direct MF</label>
                    <label className="row_val">{plan.direct_MF}</label>
                </div>
                <div>
                    <label className="row_lbl">Min Brokerage</label>
                    <label className="row_val">{plan.min_brokerage}</label>
                </div>
            </div>
            <div className="row4 row">
                <div>
                    <label className="row_lbl">Waive off-DP AMC charges</label>
                    <label className="row_val">{plan.Waive_off_on_DP_AMC_chrgs}</label>
                </div>
                <div>
                    <label className="row_lbl">
                        PMS, AIF
                        <br /> setup fees
                    </label>
                    <label className="row_val discount_row_val">
                        {plan.structured_products_AIF_setup_fees} {plan.structured_products_AIF_setup_fees && plan.structured_products_AIF_setup_fees !== "NIL" ? "discount" : ""}
                    </label>

                </div>
                <div>
                    <label className="row_lbl">Total Benefits worth (Rs.)</label>
                    <label className="row_val">{toINR(plan.total_benefits)}</label>
                </div>
            </div>
        </>
    );
}
